module.exports = __webpack_public_path__ + "img/delete.55ae9c5c.svg";